.strip {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.8rem 1.6rem;

  &:not(:last-child) {
    border-bottom: 0.1rem solid var(--color-stroke-default);
  }

  &[data-header='true'] {
    background: var(--color-surface-secondary);
    border: none;
  }
}

.left {
  display: flex;
  flex-direction: row;
  align-items: center;

  & > div:last-child {
    margin-inline-end: 0.4rem;
    margin-inline-start: 0.8rem;
  }
}

.wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;

  &[data-full-width='true'] {
    flex: 1;
  }
}

.tag-label {
  display: flex;
  white-space: nowrap;
  /* was TAG_INNER_HORIZONTAL_PADDING (0.8) from the .tsx */
  padding: 0.4rem 0.8rem;
  border: 0.1rem solid;
  border-color: var(--tag-color, var(--content-border-color));
  border-radius: 10rem;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  font-size: 1.2rem;
  font-weight: 400;
  color: var(--color-grayscale-white);
  min-width: auto;
  background-color: var(--app-background);
  max-width: 100%;

  > span {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover,
  &:focus {
    cursor: pointer;
    /* The original was `${color}20 || 'rgba(250, 250, 250, 0.2)'`. A template
       literal is always truthy, so that fallback was unreachable: with no
       colour it produced `undefined20`, which browsers drop. The custom
       property is likewise only set when a colour is given, so no
       background-color applies here without one — same result. */
    background-color: var(--tag-color-hover);
  }

  &:last-child {
    /* was ADD_TAG_WIDTH (4.8) from the .tsx */
    min-width: 4.8rem;

    &:hover,
    &:focus {
      cursor: pointer;

      svg {
        color: var(--color-grayscale-white);
      }
    }
  }
}

.point {
  background-color: var(--tag-color, var(--content-border-color));
  height: 0.8rem;
  width: 0.8rem;
  min-width: 0.8rem;
  border-radius: 50%;
}
